import React from 'react';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {GapFillingEditStore} from './GapFillingEditStore';
import {GapFillingBehaviorSelect} from './parts/GapFillingBehaviorSelect';
import {GapFillingPreview} from './parts/GapFillingPreview';
import {GapFillingTextArea} from './parts/GapFillingTextArea';
import {GapSpecifications} from './parts/GapSpecifications';

export function* gapFillingEditStoreRenderer(store: GapFillingEditStore): ReactNodeGenerator {
  yield (
    <div key="behavior" className="row justify-content-end">
      <div className="col-4">
        <div className="form-group">
          <div className="label">Behavior</div>
          <GapFillingBehaviorSelect store={store}/>
        </div>
      </div>
    </div>);

  yield (
    <div key="text-area" className="row">
      <div className="col">
        <div className="form-group">
          <GapFillingTextArea store={store}/>
        </div>
      </div>
    </div>);

  yield (<GapSpecifications key="gaps" store={store}/>);

  yield (<GapFillingPreview key="preview" store={store}/>);
}
